import { call, put, takeLatest } from "redux-saga/effects";
import { syncResumeDataSuccess, syncResumeDataFailure } from "./actions";
import { SYNC_RESUME_DATA_REQUEST } from "../../actionTypes";
import AxiosInstance from "../../../services/AxiosInstance";

function* syncResumeData(action) {
  try {
    const response = yield call(() =>
      AxiosInstance().post("/recruiter/sync_resume_data", action.payload)
    );
    console.log("Sync resume data response:", response);
    if (response.data.status) {
      yield put(syncResumeDataSuccess(response.data));
    } else {
      yield put(syncResumeDataFailure(response.data));
    }
  } catch (error) {
    console.error("Sync resume data error:", error);
    yield put(syncResumeDataFailure({ status: false, message: error.message }));
  }
}

function* syncResumeDataSaga() {
  yield takeLatest(SYNC_RESUME_DATA_REQUEST, syncResumeData);
}

export default syncResumeDataSaga; 